import { Action } from "@ngrx/store";

export enum ProductActionTypes {
  GET_PRODUCT_LIST = "[Products] Get Product List",
  GET_PRODUCT_LIST_SUCCESS = "[Products] Get Product List Success",
  GET_PRODUCT_LIST_FAILURE = "[Products] Get Product List Error",
  GET_PAGED_PRODUCT_LIST = "[Products] Get Paginated Product List",
  GET_PAGED_PRODUCT_LIST_SUCCESS = "[Products] Get Paginated Product List Success",
  GET_PAGED_PRODUCT_LIST_FAILURE = "[Products] Get Paginated Product List Error",
  CLEAR_PRODUCT_LIST = "[Products] Clear Product List",

  GET_PRODUCT_CONFIGURATION = "[Products] Get Product Configuration",
  GET_PRODUCT_CONFIGURATION_SUCCESS = "[Products] Get Product Configuration Success",
  GET_PRODUCT_CONFIGURATION_FAILURE = "[Products] Get Product Configuration Error",

  CREATE_PRODUCT_CONFIGURATION = "[Products] Create Product Configuration",
  CREATE_PRODUCT_CONFIGURATION_SUCCESS = "[Products] Create Product Configuration Success",
  CREATE_PRODUCT_CONFIGURATION_FAILURE = "[Products] Create Product Configuration Error",

  UPDATE_PRODUCT_CONFIGURATION = "[Products] Update Product Configuration",
  UPDATE_PRODUCT_CONFIGURATION_SUCCESS = "[Products] Update Product Configuration Success",
  UPDATE_PRODUCT_CONFIGURATION_FAILURE = "[Products] Update Product Configuration Error",

  CLEAR_UPDATE_PRODUCT_CONFIGURATION = "[Products] Clear Update Product Configuration",
  CLEAR_PRODUCT_CONFIGURATION = "[Products] Clear Product Configuration",
}

export class GetProductList implements Action {
  readonly type = ProductActionTypes.GET_PRODUCT_LIST;
  constructor(public payload: any) { }
}

export class GetProductListSuccess implements Action {
  readonly type = ProductActionTypes.GET_PRODUCT_LIST_SUCCESS;
  constructor(public payload: any) { }
}

export class GetProductListFailure implements Action {
  readonly type = ProductActionTypes.GET_PRODUCT_LIST_FAILURE;
  constructor(public payload: any) { }
}

export class GetPagedProductList implements Action {
  readonly type = ProductActionTypes.GET_PAGED_PRODUCT_LIST;
  constructor(public payload: any) { }
}

export class GetPagedProductListSuccess implements Action {
  readonly type = ProductActionTypes.GET_PAGED_PRODUCT_LIST_SUCCESS;
  constructor(public payload: any) { }
}

export class GetPagedProductListFailure implements Action {
  readonly type = ProductActionTypes.GET_PAGED_PRODUCT_LIST_FAILURE;
  constructor(public payload: any) { }
}

export class ClearProductList implements Action {
  readonly type = ProductActionTypes.CLEAR_PRODUCT_LIST;
  constructor() { }
}

export class GetProductConfiguration implements Action {
  readonly type = ProductActionTypes.GET_PRODUCT_CONFIGURATION;
  constructor() { }
}

export class GetProductConfigurationSuccess implements Action {
  readonly type = ProductActionTypes.GET_PRODUCT_CONFIGURATION_SUCCESS;
  constructor(public payload: any) { }
}

export class GetProductConfigurationFailure implements Action {
  readonly type = ProductActionTypes.GET_PRODUCT_CONFIGURATION_FAILURE;
  constructor(public payload: any) { }
}

export class CreateProductConfiguration implements Action {
  readonly type = ProductActionTypes.CREATE_PRODUCT_CONFIGURATION;
  constructor(public payload: any) { }
}

export class CreateProductConfigurationSuccess implements Action {
  readonly type = ProductActionTypes.CREATE_PRODUCT_CONFIGURATION_SUCCESS;
  constructor(public payload: any) { }
}

export class CreateProductConfigurationFailure implements Action {
  readonly type = ProductActionTypes.CREATE_PRODUCT_CONFIGURATION_FAILURE;
  constructor(public payload: any) { }
}

export class UpdateProductConfiguration implements Action {
  readonly type = ProductActionTypes.UPDATE_PRODUCT_CONFIGURATION;
  constructor(public payload: any, public id: any) { }
}

export class UpdateProductConfigurationSuccess implements Action {
  readonly type = ProductActionTypes.UPDATE_PRODUCT_CONFIGURATION_SUCCESS;
  constructor(public payload: any) { }
}

export class UpdateProductConfigurationFailure implements Action {
  readonly type = ProductActionTypes.UPDATE_PRODUCT_CONFIGURATION_FAILURE;
  constructor(public payload: any) { }
}

export class ClearUpdateProductConfiguration implements Action {
  readonly type = ProductActionTypes.CLEAR_UPDATE_PRODUCT_CONFIGURATION;
  constructor() { }
}

export class ClearProductConfiguration implements Action {
  readonly type = ProductActionTypes.CLEAR_PRODUCT_CONFIGURATION;
  constructor() { }
}

export type ProductActions =
  | GetProductList
  | GetProductListSuccess
  | GetProductListFailure
  | GetPagedProductList
  | GetPagedProductListSuccess
  | GetPagedProductListFailure
  | ClearProductList
  | GetProductConfiguration
  | GetProductConfigurationSuccess
  | GetProductConfigurationFailure
  | CreateProductConfiguration
  | CreateProductConfigurationSuccess
  | CreateProductConfigurationFailure
  | ClearProductConfiguration
  | UpdateProductConfiguration
  | UpdateProductConfigurationSuccess
  | UpdateProductConfigurationFailure
  | ClearUpdateProductConfiguration;
